export const PARTNER_LINK = "https://www.heilys.de/43973566";
export const DISCOUNT_CODE = "LONGEVITY";
export const DISCOUNT_PERCENT = 5;
